module.exports = __webpack_public_path__ + "img/frame (146).79cf1b48.jpg";